/**
 * ProjectProgressPage — RETIRÉE (Chunk 9.V.2c-PMG, finding S4).
 *
 * 9.R.1 affichait le contenu brut de 3 docs internes chargés via `import("…?raw")`,
 * ce qui embarquait ces docs dans les chunks JS statiques (récupérables sans auth).
 * Les docs étant ops/dev internes (non client-safe), la fonctionnalité est retirée :
 * toute route `/internal/progress/:slug` redirige désormais vers 404. Aucun contenu
 * interne n'est plus chargé ni bundlé. Cf. `lib/projectDocs.ts`.
 */

import { Navigate } from "react-router-dom";

export function ProjectProgressPage() {
  // Fonctionnalité retirée (bloqueur pré-merge S4) — aucune donnée interne servie.
  return <Navigate to="/404" replace />;
}
